import React, { useState, useEffect } from "react";
import axios from "axios";
import ForecastDay from "./ForecastDay";
import { InfinitySpin } from "react-loader-spinner";

export default function Forecast(props) {
  let [loaded, setLoaded] = useState(false);
  let [forecast, setForecast] = useState(null);

  useEffect(() => {
    setLoaded(false);
  }, [props.coords]);

  function showForecast(response) {
    setForecast(response.data.daily);
    setLoaded(true);
  }

  function calcForecast() {
    let key = `b8f1o699a3b107e215cf47a31fc0ate8`;
    let url = `https://api.shecodes.io/weather/v1/forecast?lon=${props.coords.lon}&lat=${props.coords.lat}&key=${key}`;
    axios.get(url).then(showForecast);
  }

  if (loaded) {
    return (
      <div className="row">
        {forecast.map(function (dailyForecast, index) {
          if (index < 6) {
            return (
              <div className="col" key={index}>
                <ForecastDay forecast={dailyForecast} />
              </div>
            );
          }
        })}
      </div>
    );
  } else {
    calcForecast();
    return (
      <div className="Loading">
        <InfinitySpin width="150" color="#609FFE" />
      </div>
    );
  }
}
